
import { defineComponent, PropType } from "vue";
import { Receita } from "@/api/interfacesReceita";
import ApiReceita from "@/api/apiReceita";
import toast from "@/core/toast";

export default defineComponent({
  Name: "ContainerReceita",
  props: {
    rec: {
      type: Object as PropType<Receita>,
      required: true
    }
  },
  setup(props, { emit }) {
    async function deleteReceita() {
      const request = new ApiReceita();
      const id = props.rec.id == null ? 0 : props.rec.id;
      if (confirm("Tem certeza que deseja deletar?")) {
        await request
          .deleteReceita(id)
          .then(() => {
            toast.success("Deletamos essa receita pra você.", "Ótimo");
            emit("recarrega", true);
          })
          .catch(err => {
            toast.error(err, "Ops");
          });
      }
    }

    return {
      deleteReceita,
      props
    };
  }
});
